import {IonButton, IonLabel, IonText} from "@ionic/react";
import React from "react";
import {PulseViewModel} from "../../viewModel/PulseView.model";
import {format, parseISO} from "date-fns";
import {DATEFORMATSTRING, TIMEFORMATSTRING} from "../../constants";
import {splitText} from "../../utilities/PulseMessageHelper";
import {PulseImageView} from "./PulseImageView";
import {Capacitor} from "@capacitor/core";
import {PulseAttachmentsView} from "./PulseAttachmentsView";

export interface PulseContentProps {
    pulse: PulseViewModel;
    showReadMore: boolean;
    showHorizontalRule: boolean;
}

export function PulseContent({pulse, showReadMore, showHorizontalRule = false}: PulseContentProps) {
    const dateObj = parseISO(pulse.postDate);
    const formattedDate = format(dateObj, DATEFORMATSTRING);
    const formattedTime = format(dateObj, TIMEFORMATSTRING);
    let pulseText;
    if (pulse && pulse.attachments && pulse.attachments.length > 0) {
        pulseText = <PulseAttachmentsView pulseMessage={pulse.message} attachments={pulse.attachments} ></PulseAttachmentsView>
            // <PulseImageView pulse={pulse}/>
    } else {
        pulseText = <IonText>
            <pre className={'preWrap'}>{pulse.message}</pre>
        </IonText>;
        if (showReadMore) {
            const split = splitText(pulse.message);
            pulseText = <IonText>{split.text}{split.wasSplit && <span className={'muted'}>&nbsp;Read More</span>}</IonText>
        }
    }

    const openLocation = (e: any) => {
        e.stopPropagation();

        if (Capacitor.isNativePlatform()) {
            if (Capacitor.getPlatform() === 'ios') {
                window.open(`http://maps.apple.com/?ll=${pulse.latitude},${pulse.longitude}&q=${pulse.latitude},${pulse.longitude}`)
            } else {
                window.open(`geo:${pulse.latitude},${pulse.longitude}?q=${pulse.latitude},${pulse.longitude}`, '_system');
            }
        } else {
            window.open(`https://maps.google.com/?q=${pulse.latitude},${pulse.longitude}`)
        }
    };


    return (
        <IonLabel id="pulseContent">
            <IonLabel><strong>{pulse.pulseName}</strong></IonLabel>
            <p><small>{formattedDate}, {formattedTime}</small></p>
            {pulse.announcerFirstName && <p><small>From: {pulse.announcerFirstName} {pulse.announcerLastName}</small></p>}
            {pulse.latitude && <p><IonButton onClick={openLocation}>View Location</IonButton><br/></p>}
            {pulse.pulseCategory && <p>Category: {pulse.pulseCategory}</p>}
            {showHorizontalRule && <hr style={{backgroundColor: "black"}}/>}
            {pulseText}
        </IonLabel>
    )
}
